<template>
  <div>
    <b-row>
        <b-col>
            <h5 class="page-title">
                {{$t("Clients")}}
            </h5>
        </b-col>
    </b-row>
    <br>
    <b-row>
        <b-col>
            <b-table responsive class="clients-table" :items="items">
                <template #head(options)="data">
                    <div>
                        <span :test-data="data">
                            &nbsp;
                        </span>
                    </div>
                </template>
                <template #cell(options)="data">
                    <div>
                        <span id="open-equipments" :test-data="data" class="t-link2" @click="$router.push('equipments')">
                            {{$t("Equipments")}}
                            <b-icon-chevron-right/>
                        </span>
                    </div>
                </template>
            </b-table>
        </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    methods:{
        dateParse(date_iso){
            let date = new Date(date_iso)
            let day_month = date.toLocaleDateString().substr(0,6)
            let year = date.getFullYear().toString().substr(-2)
            return `${day_month}${year}`
        }
    },
    data() {
      return {
        items: [
            {
                client: "Hospital geral 1",
                location: "Brasil",
                equipment: "03",
                active_modules: "Sim",
                options: "",
            },
            {
                client: "Hospital geral 3",
                location: "Europa",
                equipment: "12",
                active_modules: "Não",
                options: "",
            },
            {
                client: "Nome do cliente",
                location: "Europa",
                equipment: "02",
                active_modules: "Sim",
                options: "",
            },
            {
                client: "Distribuidor",
                location: "Brasil",
                equipment: "15",
                active_modules: "Não",
                options: "",
            },{
                client: "Hospital geral 1",
                location: "Brasil",
                equipment: "03",
                active_modules: "Sim",
                options: "",
            },
            {
                client: "Hospital geral 3",
                location: "Europa",
                equipment: "12",
                active_modules: "Não",
                options: "",
            },
            {
                client: "Nome do cliente",
                location: "Europa",
                equipment: "02",
                active_modules: "Sim",
                options: "",
            },
            {
                client: "Distribuidor",
                location: "Brasil",
                equipment: "15",
                active_modules: "Não",
                options: "",
            },{
                client: "Hospital geral 1",
                location: "Brasil",
                equipment: "03",
                active_modules: "Sim",
                options: "",
            },
            {
                client: "Hospital geral 3",
                location: "Europa",
                equipment: "12",
                active_modules: "Não",
                options: "",
            },
            {
                client: "Nome do cliente",
                location: "Europa",
                equipment: "02",
                active_modules: "Sim",
                options: "",
            },
            {
                client: "Distribuidor",
                location: "Brasil",
                equipment: "15",
                active_modules: "Não",
                options: "",
            },{
                client: "Hospital geral 1",
                location: "Brasil",
                equipment: "03",
                active_modules: "Sim",
                options: "",
            },
            {
                client: "Hospital geral 3",
                location: "Europa",
                equipment: "12",
                active_modules: "Não",
                options: "",
            },
            {
                client: "Nome do cliente",
                location: "Europa",
                equipment: "02",
                active_modules: "Sim",
                options: "",
            },
            {
                client: "Distribuidor",
                location: "Brasil",
                equipment: "15",
                active_modules: "Não",
                options: "",
            },
        ],
        fields:[
            {
                key: 'client',
                label: 'Client'
            },
            {
                key: 'location',
                label: 'Location'
            },
            {
                key: 'equipment',
                label: 'Equipments'
            },
            {
                key: 'active_modules',
                label: 'Active modules'
            },
            {
                key: 'options',
                label: '&nbsp;'
            },
        ]
      }
    }
  }
</script>

<style lang="scss">
    .clients-table{
        tbody{
            td:nth-child(5){
                text-align:right !important;
                white-space: nowrap;
            }
        } 
    }
</style>